module.exports = __webpack_public_path__ + "static/media/Rhyhorn_gaussian2.5d2feec0.png";